import { VisuallyHidden } from '@reach/visually-hidden'
import { useSelector } from 'react-redux'

import Spinner from '@/components/Spinner'
import { translate } from '@/utils/translations'

const BUTTON_STYLES = [
  'vst-btn--medium',
  'vst-btn--orange'
].join(' ')

const SubmitButton = () => {
  const isUpdating = useSelector(state => state.cart.promoCode.isUpdating)

  return (
    <Choose>
      <When condition={isUpdating}>
        <VisuallyHidden>
          <span role='status'>{translate('promo_code.processing')}</span>
        </VisuallyHidden>
        <button className={BUTTON_STYLES}>
          <Spinner styles='sk-spinner-three-bounce-white' />
        </button>
      </When>
      <Otherwise>
        <input
          className={BUTTON_STYLES}
          name='submit'
          type='submit'
          value={translate('promo_code.apply')}
        />
      </Otherwise>
    </Choose>
  )
}

export default SubmitButton
